import { Col, Row } from "antd";
import CardQuestion from "../CardQuestion";
import { FormattedMessage } from "react-intl";

const Container = ({ blockTitle, title, children, content }) => {
  return (
    <div style={{ marginTop: "2rem" }}>
      <p className="roi--patient-exp-acq-sub-title">
        <FormattedMessage id={blockTitle} />
      </p>

      <Row gutter={16} align={"middle"}>
        <Col span={16}>{children}</Col>
        <Col span={1} />
        <Col span={7}>
          <CardQuestion
            title={title}
            content={content}
            contentValues={
              content === "patientFeedbackinfo"
                ? {
                    link: (chunks) => (
                      <a
                        href="https://drive.google.com/file/d/112b1ma55kBVovUIL6yNn9tUJ-Odx32OC/view?usp=sharing"
                        style={{
                          textDecoration: "underline",
                          fontWeight: "bold",
                          color: "black",
                        }}
                        target="_blank"
                      >
                        {chunks}
                      </a>
                    ),
                  }
                : content === "impactPatientInfo"
                ? {
                    strong: (chunks) => <strong>{chunks}</strong>,
                  }
                : content === "revenuePerVisitInfo"
                ? {
                    strong: (chunks) => <strong>{chunks}</strong>,
                    br: (chunks) => <br />,
                  }
                : undefined
            }
          />
        </Col>
      </Row>
    </div>
  );
};

export default Container;
